import { Mtds, XIcon } from 'prove-common'
import { CheckIcon } from '../../index'

type SaveChangesBannerProps = {
  onSave: () => void
  onDiscard: () => void
  isError?: boolean
  disableSaveOnError?: boolean
  isSaving?: boolean
  saveButtonLabel?: string
  discardButtonLabel?: string
  headerText?: string
  errorText?: string
}

export const SaveChangesBanner = ({
  onSave,
  onDiscard,
  isError = false,
  disableSaveOnError = true,
  isSaving = false,
  saveButtonLabel = 'Lagre',
  discardButtonLabel = 'Forkast endringer',
  headerText = 'Du har gjort endringer som ikke er lagret',
  errorText = 'Endringene kan ikke lagres. Vennligst rett opp feilene før du lagrer.'
}: SaveChangesBannerProps) => {
  const isDisabled = (isError && disableSaveOnError) || isSaving

  return (
    <Mtds.Card
      data-color={isError ? 'danger' : 'inverted'}
      className='save-changes-banner fixed bottom-4 left-0 md:left-15 right-0 z-1000 mx-auto'
    >
      <Mtds.Flex className='save-changes-banner__content w-full items-center justify-between'>
        <Mtds.Heading as='h4'>{headerText}</Mtds.Heading>
        <Mtds.Flex>
          <Mtds.Button
            data-variant='secondary'
            onClick={onDiscard}
            disabled={isSaving}
          >
            <XIcon />
            {discardButtonLabel}
          </Mtds.Button>
          <Mtds.Button
            data-variant='primary'
            onClick={onSave}
            disabled={isDisabled}
          >
            {isSaving ? (
              <Mtds.Spinner data-size='sm' aria-label='Lagrer' />
            ) : (
              <CheckIcon />
            )}
            {isSaving ? 'Lagrer...' : saveButtonLabel}
          </Mtds.Button>
        </Mtds.Flex>
      </Mtds.Flex>
      {isError && !isSaving && <p>{errorText}</p>}
    </Mtds.Card>
  )
}
